import React from 'react';
import { Fixed } from 'layouts';
import RagQueries from './RagQueries';

const LayoutWrapper = () => {
  return (
    <Fixed>
      <RagQueries />
    </Fixed>
  );
};

export default LayoutWrapper;
